import { isNil, each } from 'lodash';
import mutationTypes from './mutationTypes';

export default {
  [mutationTypes.SET_CONFIG](state, config) {
    state.config = config;
  },
  [mutationTypes.UPDATE_CONFIG](state, property) {
    const key = Object.keys(property)[0];
    const value = Object.values(property)[0];
    state.config[key] = value;
  },
  [mutationTypes.SET_NEXT_GEN_CONFIG](state, config) {
    state.nextGenConfig = config.settings;
    window.igniteInstance = config.ignite;
  },
  [mutationTypes.SET_PRODUCT_RESULTS](state, data) {
    state.resultsData = [];
    const formatedResults = [];
    each(data, (round) => {
      if (round.balls.length === 35) {
        formatedResults.push(round);
      }
    });
    state.resultsData = formatedResults;
  },
  [mutationTypes.SET_PRODUCT_STATS](state, statsData) {
    state.stats = {};
    state.stats = statsData;
  },
  [mutationTypes.SET_ACTIVE_BETTING_TAB](state, index) {
    state.activeBettingTab = index;

    for (let i = 0; i < state.balls.length; i += 1) {
      if (!state.balls[i].style) {
        state.balls[i].style = {};
      }

      state.balls[i].style.active = state.balls[i].tabs.indexOf(state.activeBettingTab) > -1;
    }

    if (state.balls.length < 49) {
      state.balls.push({
        fake: true,
        tabs: [],
      });
    } else {
      state.balls.splice(48, state.balls.length - 1);
    }
  },
  [mutationTypes.SET_BALLS](state) {
    state.balls = [];

    for (let ball = 1; ball < 50; ball += 1) {
      state.balls.push({
        ball,
        tabs: [],
        type: null,
        style: {
          clear: (ball - 1) % 8 === 0,
        },
      });
    }
  },
  [mutationTypes.UPDATE_BALLS](state, ball) {
    state.balls = state.balls.map((b) => {
      if (ball && ball.ball === b.ball) {
        // Update the style properties
        // eslint-disable-next-line
        b.style = {
          ...b.style,
          disabled: ball.style?.disabled || b.style?.disabled,
          active: ball.style?.active || b.style?.active,
        };

        // Update the tabs
        if (ball.tabs) {
          // eslint-disable-next-line
          b.tabs = ball.tabs;
        }

        // Handle the click event
        if (ball.click) {
          const tabIndex = b.tabs.indexOf(state.activeBettingTab);
          if (tabIndex > -1) {
            b.tabs.splice(tabIndex, 1);
          } else {
            b.tabs.push(state.activeBettingTab);
          }
        }

        // Update the type
        // eslint-disable-next-line
        b.type = !isNil(ball.type) ? ball.type : b.type;
      }

      // Ensure the ball has a style object
      if (!b.style) {
        // eslint-disable-next-line
        b.style = {};
      }

      // Set the active state based on the tabs
      // eslint-disable-next-line
      b.style.active = b.tabs.includes(state.activeBettingTab);

      return b;
    });

    // Maintain a minimum number of balls
    if (state.balls.length < 50) {
      state.balls.push({
        fake: true,
        tabs: [],
      });
    } else {
      state.balls = state.balls.slice(0, 49);
    }
  },
  [mutationTypes.RESET_BALLS](state) {
    state.balls.forEach((ball) => {
      const tabIndex = ball.tabs.indexOf(state.activeBettingTab);
      if (tabIndex > -1) {
        ball.tabs.splice(tabIndex, 1);
        if (ball.style) {
          // eslint-disable-next-line
          ball.style.active = false;
        }
      }
    });

    // Maintain a minimum number of balls
    if (state.balls.length < 50) {
      state.balls.push({ fake: true, tabs: [] });
    } else {
      state.balls.splice(48, state.balls.length - 48);
    }
  },

  [mutationTypes.RESET_COLOR_BET](state) {
    state.colorBet = null;
  },
  [mutationTypes.UPDATE_MOST_LEAST_DRAWN](state, data) {
    state.drawnMost = [];
    state.drawnLeast = [];
    state.drawnMost = data.drawnMostTimes;
    state.drawnLeast = data.drawnLeastTimes;
  },
  [mutationTypes.UPDATE_ROUND](state, round) {
    state.round = round;
  },
  [mutationTypes.SET_DRAWN_COLOR](state, ball) {
    state.colorsDrawn[Math.floor((ball - 1) / 8)] += 1;
  },
  [mutationTypes.SET_COLOR_BET](state, bet) {
    state.colorBet = bet;
  },
  [mutationTypes.RESET_COLORS](state) {
    const keys = Object.keys(state.colorsDrawn);

    for (let key = 0; key < keys.length; key += 1) {
      state.colorsDrawn[keys[key]] = 0;
    }
  },
  [mutationTypes.ADD_BETTING_TAB](state, tab) {
    state.bettingTabs.push(tab);
  },
  [mutationTypes.ALL_BETTING_DISABLED](state, isBettingDisabled) {
    state.isBettingDisabled = isBettingDisabled;
  },
  [mutationTypes.SET_CANCELED_TICKET](state, ticket) {
    state.canceledTicket = ticket;
  },
  [mutationTypes.SET_PAYIN_DISABLED_FROM_SOCKET](state, isDisabled) {
    state.payinDisabledFromSocket = isDisabled;
  },
  [mutationTypes.SET_LAST_SELECTED_BET](state, bet) {
    state.lastSelectedBet = bet;
  },
  [mutationTypes.SET_HIDE_LOADER](state, hide) {
    state.hideLoader = hide;
  },
  [mutationTypes.SET_DRAWN_BALLS_STATE_ACTIVE](state, isActive) {
    state.drawnBallsStateActive = isActive;
  },
  [mutationTypes.SET_TICKET_PAYIN_IN_PROG](state, isInProg) {
    state.isTicketPayinInProg = isInProg;
  },
  [mutationTypes.SET_PERNAMENT_BETTING_DISABLED](state, pernamentBettingDisabled) {
    state.pernamentBettingDisabled = pernamentBettingDisabled;
  },
  [mutationTypes.TOGGLE_FREE_BET_MODAL](state, show) {
    state.showFreeBetModal = show;
  },
  [mutationTypes.TOGGLE_FREE_BET_EXPIRED_MODAL](state, show) {
    state.showFreeBetExpiredModal = show;
  },
  [mutationTypes.SET_LAST_DRAWN_BALL_ID](state, ball) {
    state.lastDrawnBallId = ball;
  },
  [mutationTypes.SET_NEXTGEN_STANDALONE_INTEGRATION](state, integration) {
    state.nextgenStandaloneIntegration = integration;
  },
  [mutationTypes.SET_ODDS](state, odds) {
    state.odds = odds;
  },
  [mutationTypes.CLEAR_DRAWN_BALLS](state) {
    state.drawnBalls = [];
  },
  [mutationTypes.ADD_DRAWN_BALL](state, ball) {
    state.drawnBalls.push(ball);
  },
  [mutationTypes.SET_BETTING_TAB_PROPERTIES](state, payload) {
    const { index, ...properties } = payload;
    const existing = state.bettingTabs[index];

    state.bettingTabs[index] = {
      ...existing,
      ...properties,
      style: {
        ...existing.style,
        ...properties.style,
      },
    };
  },
  [mutationTypes.SET_BALL_PROPERTIES](state, payload) {
    const { index, ...properties } = payload;
    const existing = state.balls[index];
    state.balls[index] = {
      ...existing,
      ...properties,
      style: {
        ...existing.style,
        ...properties.style,
      },
    };
  },
  [mutationTypes.SET_LESS_THAN_SIX_BALLS_LEFT](state, value) {
    state.lessThanSixBallsLeft = value;
  },
  [mutationTypes.RESET_REMAINING_BALLS](state) {
    state.remainingBalls = [];
    for (let i = 1; i < 49; i += 1) {
      state.remainingBalls.push(i);
    }
  },
  [mutationTypes.UPDATE_REMAINING_BALLS](state, ball) {
    const index = state.remainingBalls.indexOf(ball);
    if (index) {
      state.remainingBalls.splice(index, 1);
    }
  },
};
